export const getUrlParam =  function(paraName) {
  let url = document.location.toString();
  if(url.indexOf('#/') >= 0) {
    url = url.split('#/');
  }
  else {
    url = [url]
  }
  let attrs = [];
  url.map(function(item) {
    if(item.indexOf('?') >= 0) {
      attrs.push(item.split('?')[1]);
    }
  })
  attrs = attrs.join('&');
  const arrPara = attrs.split("&");
  let arr;
  for (let i = 0; i < arrPara.length; i++) {
    arr = arrPara[i].split("=");
    if (arr != null && arr[0] == paraName) {
      return arr[1];
    }
  }

  return "";
}

export const href = function(route) {
  if (route) {
    let baseUrl = window.location.pathname;//'/';
    //if (process.env.NODE_ENV !== 'development') {
    //  baseUrl = '/wap/';
    //}
    console.log(route)
    if (route === '/') {
      window.location.href = baseUrl;
    } else {
      window.location.href =
        route.indexOf('#') === 0
          ? baseUrl + route
          : baseUrl + '#' + route;
      }
  }
}

export const encode = function(str) {
  // 对字符串进行编码
  var encode = encodeURI(str);
  // 对编码的字符串转化base64
  var base64 = window.btoa(encode);
  return base64;
}

export const decode = function(base64) {
  // 对base64转编码
  var decode = window.atob(base64);
  // 编码转字符串
  var str = decodeURI(decode);
  return str;
}




// WEBPACK FOOTER //
// ./src/utils/util.js